import firebase from "firebase/app";
import { message } from "antd";

type PromiseCallback = (value?: any) => void;

const createBranchApi = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const {
    branchId,
    location,
    linkLocation,
    availability,
    club,
    services,
    photo,
    femaleOnly,
  } = payload;
  const currentTime = new Date().toISOString();
  const newBranch = {
    branchId,
    location,
    linkLocation,
    startTime: availability[0],
    endTime: availability[1],
    club,
    services,
    photo,
    femaleOnly,
    firestoreRef: branchId,
    createdAt: currentTime,
    updatedAt: currentTime,
  };
  firebase
    .firestore()
    .collection("branches")
    .doc(branchId)
    .set(newBranch)
    .then(() => {
      message.success("New Branch has been created successful!");
      resolve(newBranch);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error adding document: ", error);
      message.error("Something went wrong! please try again later!");
      reject(error);
    });
};
const fetchBranchesApi = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { currentUser, clubId } = payload;
  const branches: any[] = [];
  if (currentUser.role === "regular") reject([]);
  firebase
    .firestore()
    .collection("branches")
    .where("club", "==", clubId)
    .get()
    .then(async (querySnapshot) => {
      await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          const courtSnapshots = await firebase
            .firestore()
            .collection("courts")
            .where("branchId", "==", doc.id)
            .get();
          branches.push({ ...doc.data(), courtCount: courtSnapshots.size, key: doc.id });
        })
      );
      resolve(branches);
    });
};
const updateBranchApi = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const {
    key,
    location,
    linkLocation,
    availability,
    services,
    club,
    photo,
    femaleOnly,
    currentUser,
  } = payload;
  if (currentUser.role === "regular") reject([]);
  firebase.firestore().collection("branches").doc(key).update({
    location,
    linkLocation,
    services,
    photo,
    femaleOnly,
    startTime: availability[0],
    endTime: availability[1],
  }).then(() => {
    firebase
    .firestore()
    .collection("branches")
    .where("club", "==", club)
    .get()
    .then(async (querySnapshot) => {
      const branches: any[] = [];
      await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          const courtSnapshots = await firebase
            .firestore()
            .collection("courts")
            .where("branchId", "==", doc.id)
            .get();
          branches.push({ ...doc.data(), courtCount: courtSnapshots.size });
        })
      );
      message.success("Branch has been updated successful!");
      resolve(branches);
    })
    .catch(e => {
      console.log(e);
      message.error("Something went wrong! Please try again later!");
      reject([]);
    });
  })
  .catch(e => {
    console.log(e);
    message.error("Something went wrong! Please try again later!");
    reject([]);
  })
 
};
const deleteBranchApi = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { branchId, club } = payload;
  firebase.firestore().collection("branches").doc(branchId).delete()
  .then(() => {
    firebase
    .firestore()
    .collection("branches")
    .where("club", "==", club)
    .get()
    .then(async (querySnapshot) => {
      const branches: any[] = [];
      await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          const courtSnapshots = await firebase
            .firestore()
            .collection("courts")
            .where("branchId", "==", doc.id)
            .get();
          branches.push({ ...doc.data(), courtCount: courtSnapshots.size });
        })
      );
      message.success("Branch has been deleted successful!");
      resolve(branches);
    })
    .catch(e => {
      console.log(e);
      message.error("Something went wrong! Please try again later!");
      reject([]);
    });
  });
  
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseCreateBranch = (payload: any) =>
  new Promise(createBranchApi(payload));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseFetchBranches = (payload: any) =>
  new Promise(fetchBranchesApi(payload));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseUpdateBranch = (payload: any) =>
  new Promise(updateBranchApi(payload));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseDeleteBranch = (payload: any) =>
  new Promise(deleteBranchApi(payload));
